import styled from 'styled-components'
import { commonProps, CommonProps, sx, SxProps } from '@bestyled/system'

export interface ImageProps extends CommonProps, SxProps {
  src?: any
  alt?: string
  style?: any
}

export const Image = styled.img<ImageProps>`
  flex-grow: 1;
  object-fit: contain;
  ${commonProps} ${sx}
`

Image.displayName = 'Image'

export default Image
